import GameRanking from './GameRanking';
export default GameRanking;